export default __webpack_public_path__ + "static/media/shoes2.48341495.png";